import React from 'react';
import { ArrowRight, Phone, Mail } from 'lucide-react';

export default function FinalCTA() {
  return (
    <section id="contact" className="px-4 md:px-6 pt-6 md:pt-8">
      <div className="relative max-w-7xl mx-auto rounded-[32px] md:rounded-[40px] overflow-hidden bg-neutral-900">
        <div className="absolute -top-32 -left-24 h-80 w-80 rounded-full blur-3xl opacity-20 pointer-events-none bg-white" />
        <div className="absolute -bottom-40 -right-24 h-96 w-96 rounded-full blur-3xl opacity-10 pointer-events-none bg-white" />

        <div className="relative px-6 md:px-12 py-20 md:py-28 text-center text-white">
          <span className="reveal inline-block text-[11px] font-semibold tracking-[0.2em] uppercase text-white bg-white/10 border border-white/15 px-3 py-1.5 rounded-full">
            Contact
          </span>
          <h2 className="reveal font-display-bold mt-6 text-4xl md:text-[68px] leading-[1.05] text-white">
            Complex matter?
            <br />
            <span className="text-neutral-400">We&rsquo;ll find a way forward.</span>
          </h2>

          <div className="reveal mt-10 flex flex-col sm:flex-row justify-center gap-3">
            <a
              href="https://wa.me/918976171100"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary inline-flex items-center gap-2 bg-white text-neutral-900 text-sm font-semibold px-6 py-4 rounded-full"
            >
              Get in Touch
              <ArrowRight className="h-4 w-4" />
            </a>
            <a
              href="https://calendly.com/contact-onecatalyst/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-transparent text-white border border-white/40 hover:bg-white/10 transition-colors duration-250 text-sm font-semibold px-6 py-4 rounded-full"
            >
              Schedule a Call
            </a>
          </div>

          <div className="reveal mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-2 gap-5 text-left max-w-3xl mx-auto">
            <div className="rounded-[24px] bg-white/[0.06] backdrop-blur-sm border border-white/10 p-6 md:p-7">
              <div className="h-11 w-11 rounded-2xl bg-white/10 flex items-center justify-center">
                <Phone className="h-4 w-4 text-white" strokeWidth={2} />
              </div>
              <div className="mt-5 text-[11px] uppercase tracking-widest text-neutral-400">Call / WhatsApp</div>
              <div className="mt-1 text-sm md:text-base text-white">+91‑8976171100</div>
            </div>
            <div className="rounded-[24px] bg-white/[0.06] backdrop-blur-sm border border-white/10 p-6 md:p-7">
              <div className="h-11 w-11 rounded-2xl bg-white/10 flex items-center justify-center">
                <Mail className="h-4 w-4 text-white" strokeWidth={2} />
              </div>
              <div className="mt-5 text-[11px] uppercase tracking-widest text-neutral-400">Mail</div>
              <div className="mt-1 text-sm md:text-base text-white">contact@onecatalyst.in</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
